<template>
  <a-card size="small" title="筛选条件" :bordered="false">
    <a-form-model class="search-form">
      <a-form-model-item>
        <span style="margin-right: 8px">时间:</span>
        <a-range-picker v-model="checkedDate" :default-value="checkedDate" :allow-clear="false" />
      </a-form-model-item>
    </a-form-model>
  </a-card>
</template>

<script>
import moment from 'moment';

export default {
  name: 'DataFilter',
  data() {
    return {
      checkedDate: [moment().subtract(1, 'month').add(1, 'day'), moment()],
      labelCol: { span: 1 },
      wrapperCol: {},
      plainOptions: []
    };
  },

  computed: {
    filter() {
      const { checkedDate } = this;
      return {
        checkedDate
      };
    }
  },

  watch: {
    filter() {
      this.$emit('change', this.checkedDate);
    }
  },
  created() {
    this.$emit('change', this.checkedDate);
  },

  methods: {}
};
</script>

<style lang="less" scoped>
.ant-form-item {
  margin-bottom: 0px;
  border-bottom: silver 1px dashed;
}
</style>
